import type { PropTypes, PropElement } from "@platform/react-storybook/Component";

import type { UuidBitmapAsset } from "@common/content/asset/bitmap";
import type { UuidCategory } from "@common/content/category";

import type { UuidText } from "@front/components/Element/Text/types";

import Namespace from "./_index.scss";

export const { NAME_CATEGORIES, TYPE_CATEGORIES } = Namespace;

export type CardCategories = PropElement & {
    uuid: UuidCategory;
    title: UuidText;
    pills: UuidText[];
    summary: UuidText;
    bitmap: UuidBitmapAsset;
    href: string;
};

export type PropCategories = {
    cards: CardCategories[];
};

export const DEF_CATEGORIES = {};

export type PropTypesCategories = PropTypes<PropCategories, typeof DEF_CATEGORIES>;
